import React, {
  FC,
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef,
} from "react"
import { useRequest } from "ahooks"
import { getParks, getParkReport, getFlows, getIndustry } from "@/api/park"
import { TReportPark, TReportFlow } from "@/api/interfacePark"
import PieMore from "@components/LabelRatioPie/more"
import Map from "./components/Map"
import GradientRanking from "@components/Bar/gradient"
import ErectRadio from "@components/Bar/erectRadio"
import Loading from "@/components/Loading"
import Block from "@/components/BlockWrap"
import BlockTitle from "@/components/BlockTitle"
import Tab from "@components/Tab"
import { useSetState } from "@/reactUse"
import { getScatterSeries, getFlyLineSeries } from "@util/chart"
import Env from "@util/env"
import IndustryList from "./components/industryList"
import Selector from "@/components/Selector"
import { observer, useLocalStore } from "mobx-react" // 6.x or mobx-react-lite@1.4.0
import "./index.scss"

const InitialCenter = [121.69008, 31.124099]
const Tabs = {
  industry: [
    { name: "集成电路", key: "0", center: [121.730592, 31.037653], zoom: 10 },
    { name: "生物医药", key: "1", center: [121.632745, 31.146727], zoom: 11 },
    { name: "人工智能", key: "2", center: [121.741578, 31.049713], zoom: 10 },
  ],
  internationalHR: [
    { name: "人才输入", key: "0" },
    { name: "人才输出", key: "1" },
  ],
  HR: [
    { name: "人才输入", key: "0" },
    { name: "人才输出", key: "1" },
  ],
}
const Home: FC = () => {
  const refResidentialCity = useRef<any>([])
  const store = useLocalStore(() => ({
    currentHeat: 0, // 热力index
    currentFly: 0, // 飞线index
    currentHeatKey: "zj", // 热力key
    currentProfileKey: "zj", // 画像key
    industryOn: false, //
    changeArea(item, active, i) {
      // 更改画像
      store.currentProfileKey = item.key
    },
    changeHeat(item, active, i) {
      // 更改热力
      store.currentHeatKey = active ? item.key : null
      if (active) {
        store.currentProfileKey = item.key
      }
    },
    changeFly(item, active, idx) {
      // 更改飞线
      store.currentFly = active ? idx : -1
    },
    toogleIndustry(active) {
      // 产业分布开关（画像，poi）
      store.industryOn = active
    },
  }))
  const InitialZoom = 10 + Env.getScale()
  const [report, setReport] = useState<TReportPark | null>(null)
  const [flows, setFlows] = useState<TReportFlow | null>(null)
  const { data: parks, loading } = useRequest(getParks, {})
  const { data: industryList } = useRequest(getIndustry, {})
  const [state, setState] = useSetState({
    series: [],
    zoom: InitialZoom,
    center: InitialCenter,
    pois: [],
    flyList: [],
    population: [],
  })
  const tabs = useMemo(() => {
    return [
      { name: "人才输入", key: "ins", color: "#00FFDB" },
      { name: "人才输出", key: "outs", color: "#00FFDB" },
    ]
  }, [])
  const [currentTab, setCurrentTab] = useSetState({
    residentialCity: 0,
    industry: 0,
    internationalHR: 0,
    HR: 0,
  })
  /**
   * 获取园区报告
   */
  const getReport = useCallback(
    (key) => {
      getParkReport(key).then((_report) => {
        if (_report) {
          setReport(_report)
          if (key === "zj") {
            setState({
              population: [
                {
                  name: "到访指数",
                  count: 942024,
                  lineColor: "#2C9FD4",
                  bgColor: "#23536A",
                },
                {
                  name: "职住人口指数",
                  count: 562573,
                  lineColor: "#00B558",
                  bgColor: "#125C3A",
                },
                // {
                //   name: "人才数量",
                //   count: 466302,
                //   lineColor: "#C74E58",
                //   bgColor: "#5F343A",
                // },
                // {
                //   name: "工作人口指数",
                //   count: _report.population.work,
                //   lineColor: "#BFA639",
                //   bgColor: "#48472C",
                // },
              ],
            })
          }
        }
      })
      if (/^[a-zA-Z]+$/.test(key)) {
        getFlows(key).then((flows) => {
          setFlows(flows)
        })
      }
    },
    [setReport]
  )

  const { gender, age, residentialArea, residentialCity, shoppingMall } =
    useMemo(() => {
      if (!report) {
        return {
          gender: [],
          age: [],
          residentialArea: [],
          residentialCity: [],
          shoppingMall: [],
        }
      }
      let {
        age,
        gender,
        residentialArea,
        residentialCity = [],
        shoppingMall,
      } = report
      if (residentialCity.length >= 6) {
        refResidentialCity.current = residentialCity.slice(1, 6)
      }
      return {
        gender,
        age,
        residentialArea,
        residentialCity: residentialCity.slice(1, 6),
        shoppingMall,
      }
    }, [report])
  const { internationalHR, HR, ins, outs } = useMemo(() => {
    if (!flows) {
      return {
        internationalHR: [[]],
        HR: [[]],
        ins: null,
        outs: null,
      }
    }
    for (let key in flows) {
      let color = "#00FFDB"
      if (key.includes("international")) {
        color = "#FFF500"
      }
      flows[key].forEach((line) => (line.nameColor = color))
    }
    return {
      internationalHR: [flows.internationalHRIn, flows.internationalHROut],
      HR: [flows.HRIn, flows.HROut],
      ins: flows.internationalHRIn.concat(flows.HRIn),
      outs: flows.internationalHROut.concat(flows.HROut),
    }
  }, [flows])
  const currentIndustry = useMemo(() => {
    let list = industryList ? industryList[currentTab.industry] : []
    let tab = Tabs.industry[currentTab.industry]
    if (store.industryOn) {
      store.currentProfileKey = tab.name
    } else {
      store.currentProfileKey = "zj"
    }
    return list
  }, [currentTab.industry, store.industryOn, industryList])
  /**
   * 切换飞线模式
   */
  useMemo(() => {
    let list = null
    var icon = true
    let item = tabs[store.currentFly]
    let series = []
    let flyList = []
    if (!item) {
      series = [
        getScatterSeries("scatter_fly", [], "#FF5555", true),
        ...getFlyLineSeries("fly_a", [], "", icon),
        ...getFlyLineSeries("fly_a_inter", [], "", icon),
      ]
    } else if (item.key === "ins") {
      list = ins
    } else if (item.key === "outs") {
      list = outs
    }
    if (list) {
      series = [
        getScatterSeries("scatter_fly", list, "#FF5555", true),
        ...getFlyLineSeries(
          "fly_a",
          list.slice(6),
          list[6]["nameColor"],
          icon,
          7
        ),
        ...getFlyLineSeries(
          "fly_a_inter",
          list.slice(0, 6),
          list[(0)["nameColor"]],
          icon,
          30
        ),
      ]
      flyList = list
    }
    if (store.industryOn) {
      series.push(
        getScatterSeries("scatter_industry", currentIndustry, "#1890ff", false)
      )
    } else {
      series.push(getScatterSeries("scatter_industry", [], "#1890ff", false))
    }
    setState({
      series,
      flyList,
      // zoom: zoom + Env.getScale(),
      // center,
    })
  }, [
    setState,
    store.currentFly,
    tabs,
    ins,
    outs,
    store.industryOn,
    currentIndustry,
  ])
  // 获取画像
  useMemo(() => {
    getReport(store.currentProfileKey)
  }, [store.currentProfileKey])
  useMemo(() => {
    if (parks && parks.list) {
      let zoom = InitialZoom
      let center = InitialCenter
      let park = parks.list.find((p) => p.key === store.currentProfileKey)
      if (park) {
        zoom = park.zoom + Env.getScale()
        center = park.center
      }
      setState({
        zoom,
        center,
      })
    }
  }, [store.currentProfileKey, parks])

  // 显示industry,poi画像

  if (!report || loading) {
    return <Loading loading={loading} tip="正在获取报告数据" />
  }
  return (
    <div className="pg-parks flex flex-column">
      <div className="content flex-1">
        <Map
          indoorVisible={false}
          series={state.series}
          zoom={state.zoom}
          center={state.center}
          geo={parks ? parks.geo : null}
          nameLabels={state.flyList}
          district={store.currentHeatKey}
          activeProfileKey={store.currentProfileKey}
          store={store}
        />
        <div className="content-charts flex">
          <div className={"con-left flex flex-column"}>
            <div className="block  block-idx">
              <div className="block-inner">
                <div className="block-body">
                  {state.population.map((item, i) => {
                    let { name, count, lineColor, bgColor } = item
                    return (
                      <div className="it-idx" key={i}>
                        <BlockTitle
                          title={name}
                          lineColor={lineColor}
                          bgColor={bgColor}
                        />
                        <span className="count" style={{ color: lineColor }}>
                          {count.toLocaleString()}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <Block theme="2" title="人才性别" className="block-gender">
              <PieMore data={gender} />
            </Block>
            <Block theme="2" title="人才年龄" className="block-age">
              <ErectRadio data={age} />
            </Block>
            <Block
              theme="2"
              title="产业人才密度"
              className="block-industry"
              tabs={
                <Tab
                  list={Tabs.industry}
                  onClick={(item, i) => {
                    setCurrentTab({ industry: i })
                  }}
                />
              }
            >
              <IndustryList list={currentIndustry} idx={currentTab.industry} />
            </Block>
          </div>
          <div className="con-map flex flex-column">
            <div className="row-1">
              <Selector
                className="se-model"
                tabs={tabs}
                onClick={store.changeFly}
                icon
                currentIdx={store.currentFly}
              />
            </div>
            <div className="row-2 flex">
              <Block theme="2" title="来源地分析" closable>
                <GradientRanking
                  data={refResidentialCity.current}
                  highLightType="purple"
                  color="linear-gradient(90deg,rgba(75, 86, 115, 1) 0%,rgba(192, 50, 253, 1) 100%)"
                />
              </Block>
              <Block theme="2" title="居住小区" closable>
                <GradientRanking
                  data={residentialArea.slice(0, 5)}
                  highLightType="red"
                />
              </Block>
              <Block theme="2" title="常去商圈" closable>
                <GradientRanking
                  data={shoppingMall.slice(0, 5)}
                  highLightType="yellow"
                />
              </Block>
            </div>
          </div>
          <div className="con-right flex flex-column">
            {/* <Block
              theme="2"
              title="张江吸引境外人才排行榜"
              tabs={
                <Tab
                  list={Tabs.internationalHR}
                  onClick={(item, i) => {
                    setCurrentTab({ internationalHR: i })
                  }}
                />
              }
            >
              <GradientRanking
                data={internationalHR[currentTab.internationalHR].slice(0, 5)}
                highLightType="red"
              />
            </Block> */}
            <Block
              theme="2"
              title="张江吸引境内人才排行榜"
              tabs={
                <Tab
                  list={Tabs.HR}
                  onClick={(item, i) => {
                    setCurrentTab({ HR: i })
                  }}
                />
              }
            >
              <GradientRanking
                data={HR[currentTab.HR].slice(0, 6)}
                highLightType="red"
              />
            </Block>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(Home)
